import { animate, animateChild, AUTO_STYLE, group, keyframes, query, state, style, transition, trigger } from '@angular/animations';

export const advancedFiltersAnimations = [
  trigger('filters', [
    state('false', style({ opacity: 1, background: 'rgba(0,0,0,0.1)', transform: 'translateY(0)' })),
    state('true', style({ opacity: 0, background: 'rgba(0,0,0,0)', transform: 'translateY(-100%)' })),
    transition('false => true', [
      animate('50ms ease', style({ background: 'rgba(0,0,0,0)' })),
      animate('400ms ease', style({ transform: 'translateY(-100%)' })),
      animate('1ms ease', style({ opacity: 0 }))
    ]),
    transition('true => false', [
      animate('1ms ease', style({ opacity: 1 })),      
      animate('400ms ease', style({ transform: 'translateY(0)' })),
      animate('400ms ease', style({ background: 'rgba(0,0,0,0.1)' })),
    ])
  ]),  
  trigger('chips', [
    state('false', style({ borderColor: '#e0e0e0', boxShadow: '0px 0 6px rgba(0, 0, 0, 0)' })),
    state('true', style({ borderColor: '#8b8b8b', boxShadow: '1px 0 6px rgba(0, 0, 0, 0.4)' })),
    transition('true <=> false', group([
      query('@rotateIcon', animateChild()),
      animate('400ms ease')
    ])),
  ]),
  trigger('rotateIcon', [
    state('false', style({ transform: 'rotate(0deg)' })),
    state('true', style({ transform: 'rotate(180deg)' })),
    transition('false <=> true', animate('400ms ease-out')),
  ]),
  trigger('collapseSelect', [
    state('false', style({
      transform: 'translateX(0)',
      opacity: 1
    })),
    state('true', style({
      transform: 'translateX(-100%)',
      opacity: 0
    })),
    transition('false => true', [
      animate('400ms ease', style({ transform: 'translateX(-100%)' })),
      animate('1ms ease', style({ opacity: 0 }))
    ]),
    transition('true => false', [
      animate('1ms ease', style({ opacity: 1 })),
      animate('400ms ease', style({ transform: 'translateX(0)' }))
    ])
  ]),
  trigger('expandContent', [
    state('true', style({ marginLeft: 0 })),
    state('false', style({ marginLeft: '{{marginLeft}}px' }), { params: { marginLeft: '220px' } }),
    transition('true <=> false', animate('400ms ease'))
  ]),
  trigger('resize', [
    state('*', style({ height: '45px' })),
    state('false', style({ height: '45px' })),
    state('true', style({ height: '87px' })),
    transition('* <=> *', group([
      query('@showInput', animateChild()),
      animate('400ms ease')
    ])),
  ]),
  trigger('showInput', [
    state('*', style({ transform: 'translateY(-40px)' })),
    state('false', style({ transform: 'translateY(-40px)' })),
    state('true', style({ transform: 'translateY(-2px)' })),
    transition('* <=> *', animate('400ms ease'))
  ])
]